import { buildSalesTeamsMap } from '../../team/operators/buildSalesTeamMap';
import { teamTreeToOptions } from '../../team/operators/teamTreeToOptions';
import { RoutingTeam } from '../../users-and-teams/records/Team';
const makeTeam = team => new RoutingTeam(team);
export const buildTeamTreeOptions = (hierarchy, routingSource) => {
  const teamTree = buildSalesTeamsMap(hierarchy, makeTeam);
  return teamTreeToOptions(teamTree, routingSource);
};